import { render, staticRenderFns } from "./Disabilities.vue?vue&type=template&id=3a78dee7"
import script from "./Disabilities.vue?vue&type=script&lang=js"
export * from "./Disabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports